import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { FinancialResponsibilityIncidentModel } from '../models/financial-responsibility-incident.model';

@Injectable()
export class FinancialResponsibilityIncidentService extends IncidentServiceBase<FinancialResponsibilityIncidentModel> {
    constructor() {
        super('FinancialResponsibilityIncident', () => new FinancialResponsibilityIncidentModel());
    }
}
